// src/store/userSlice.js
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload
    },
    updateUserAvatar(state, action) {
      if (state.user) {
        state.user = {
          ...state.user,
          avatarUrl: action.payload,
        }
      }
    },
  },
})

export const { setUser, updateUserAvatar } = userSlice.actions
export default userSlice.reducer
